import { render, staticRenderFns } from "./owner-baseinfo.vue?vue&type=template&id=668a1e85&scoped=true&"
import script from "./owner-baseinfo.vue?vue&type=script&lang=js&"
export * from "./owner-baseinfo.vue?vue&type=script&lang=js&"
import style0 from "./owner-baseinfo.vue?vue&type=style&index=0&id=668a1e85&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "668a1e85",
  null
  
)

export default component.exports